import React from 'react';
import { Container } from 'react-bootstrap';
import logo from '../../img/logo.svg';
import './inCompleteStyle.scss';

const HEADER = "You're almost there!";
const DETAILS =
    "Please contact your pharmacy's TherigyVista Company or Branch Administrator to assign the appropriate role(s) and privileges to your account.";
const DETAILS_1 = 'Once assigned, you will be able to successfully access TherigyVista.';

function IncompleteConfiguration() {
    return (
        <div className="content-box">
            <Container className="container p-4 mt-3">
                <img className="branding-login" src={logo} alt="Therigy Logo" />
            </Container>
            <Container className="p-4 mt-3 log-box shadow">
                <h4>{HEADER}</h4>
                <p>{DETAILS}</p>
                <p>{DETAILS_1}</p>
            </Container>
            <div className="login-footer">
                <p className="footer-text text-center m-0">
                    For immediate assistance, contact Tech Support by phone at
                </p>
                <p className="footer-text text-center">
                    <span>407.992.8750 x3</span> or via email at
                    <span>
                        {' '}
                        <a href="mailto:support@therigy.com">support@therigy.com</a>
                    </span>
                </p>
            </div>
        </div>
    );
}
export default IncompleteConfiguration;
